import React from 'react'
import PropTypes from 'prop-types'
import ChildRow from './ChildRow'
import LazyLoad from 'react-lazyload'
import classNames from 'classnames'

class GroupChild extends React.PureComponent {

    _parseProductsItems = (item) => {
        const rows = {parent: null, child: []}
        const {labelDetails: orderLabelDetails, brand_name: orderBrandName, tags: tagOrders = [], ...itemWithoutProducts} = item
        let products = item.products
        const newTagOrders = tagOrders.filter(t => t !== "is_set") || []

        if (item.hasOwnProperty('filteredProducts')) {
            products = item.filteredProducts
        }

        const product_labels = products.filter(product => {
            return product.hasOwnProperty('labelDetails')
        })

        if (orderLabelDetails) {
            Object.assign(itemWithoutProducts, {'orderLabelDetails': orderLabelDetails})
        }

        if(orderBrandName){
            Object.assign(itemWithoutProducts, {'orderBrandName': orderBrandName})
        }

        const multiLabel = product_labels.length > 0
        Object.assign(itemWithoutProducts, {'multiLabel': multiLabel})

        delete itemWithoutProducts['note']

        const listProducts = products.slice(1)
        const {tags : tagItems = []} = !!listProducts[0] ? listProducts[0] : {}
        const tags = Array.from(new Set([...tagItems, ...newTagOrders]))

        for (let itemProduct of listProducts) {
            const {_id: productId, status, isShipped, ...restItemProduct} = itemProduct

            Object.assign(restItemProduct, {'hasLabel': restItemProduct.hasOwnProperty('labelDetails')})
            if (multiLabel === true) {
                Object.assign(restItemProduct, {'isShipped': isShipped})
            }
            rows.child.push({
                ...itemWithoutProducts,
                ...restItemProduct,
                productId,
                productStatus: status,
                isSubitem: true,
            })
        }
        rows.parent = (Object.assign({}, { tags }))
        return rows
    }

    render() {
        const { item: _item, ...rest } = this.props
        const { child = [], parent = {} } = this._parseProductsItems(_item)
        const { tags: parentTags} = parent

        return (
            <React.Fragment>
                {child.map((item, i) => {
                    const {tags} = item

                    return <div key={i} className={classNames('itemRowTable', {'item-error-2d' : tags && tags.includes('errQC')})}>
                        <LazyLoad>
                            <ChildRow item={item} parentTags={parentTags} {...rest} />
                        </LazyLoad>
                    </div>
                })}
            </React.Fragment>
        )
    }
}

GroupChild.propTypes = {
    item: PropTypes.object.isRequired,
}

export default GroupChild
